import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  buttonWrap: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    flexDirection: 'row',
    paddingTop: '8px',
    paddingBottom: '8px',
    height: '47px',
  },

  buttonWrap: {
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    width: `${100 / 3}%`,

    ':not(:last-of-type)': {
      borderRightWidth: '1px',
      borderRightStyle: 'solid',
      borderRightColor: colors.space15,
    },
  },
});

export default styles;
